import React from "react";
import "./Disclosure.css";

const Disclosure = () => {
  return (
    <div className="disclosure-page-container">
      <h1 className="disclosure-heading">Disclosure</h1>
      <h2 className="disclosure-subheading">Registered Distributor</h2>
      <p className="disclosure-text">
        We, at <b className="services-bold">United Investment Point</b>, are
        AMFI-registered mutual fund distributors. Our earnings come solely from
        commissions as product distributors, and we do not charge any additional
        fees. For any clarification or to understand more about expense ratios
        or our commissions, feel free to email us or visit our office during
        working hours (Monday to Friday, 9:30 AM to 5:30 PM).
      </p>
      <h2 className="disclosure-subheading">Product Scope</h2>
      <p className="disclosure-text">
        The information provided on this page pertains exclusively to the mutual
        fund products distributed by{" "}
        <b className="services-bold">United Investment Point</b>. Clients are
        encouraged to explore other investment options that we do not offer
        before making any decisions.
      </p>
      <h2 className="disclosure-subheading">Investment Risks</h2>
      <p className="disclosure-text">
        Mutual fund investments do not provide guaranteed or assured returns.
        The principal amount invested in mutual funds is subject to risks and
        may incur losses. Investments in mutual funds are subject to market
        risks. Please read all scheme-related documents carefully before
        investing.
      </p>
      <h2 className="disclosure-subheading">Brokerage Disclosure</h2>
      <p className="disclosure-text">
        <b className="services-bold">United Investment Point</b> receives
        commissions from Asset Management Companies (AMCs) for client
        investments in the Regular Plan of mutual fund schemes. As per SEBI
        circular, below are the details of the comparative commissions earned by
        us from various AMCs for distributing mutual fund schemes (Regular
        Plan):
      </p>
      <div className="commission-table-container">
        <table className="commission-table">
          <thead>
            <tr>
              <th>Scheme Type</th>
              <th>Trail</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Liquid/Ultra Short Term Schemes</td>
              <td>0.05% - 0.20%</td>
            </tr>
            <tr>
              <td>Short Term Income Funds</td>
              <td>0.45% - 0.50%</td>
            </tr>
            <tr>
              <td>Income Funds</td>
              <td>0.45% - 0.65%</td>
            </tr>
            <tr>
              <td>Gilt Funds</td>
              <td>0.59% - 0.90%</td>
            </tr>
            <tr>
              <td>Hybrid Debt/Monthly Income Plans</td>
              <td>0.60% - 1.20%</td>
            </tr>
            <tr>
              <td>Arbitrage Funds</td>
              <td>0.55% - 0.60%</td>
            </tr>
            <tr>
              <td>Fund of Funds</td>
              <td>0.25% - 0.50%</td>
            </tr>
            <tr>
              <td>ELSS</td>
              <td>0.65% - 1.20%</td>
            </tr>
            <tr>
              <td>Index Funds</td>
              <td>0.20% - 0.50%</td>
            </tr>
            <tr>
              <td>Equity/Hybrid Equity/Balance Funds</td>
              <td>0.65% - 1.50%</td>
            </tr>
            <tr>
              <td>Fixed Maturity Plans</td>
              <td>Variable</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="disclosure-text">
        The commission details provided above represent broad ranges for
        different categories of mutual funds distributed by us. For the purpose
        of better understanding of commission and other details, please click{" "}
        <a
          href="https://drive.google.com/drive/folders/1HnJ-HZbxQurtovFU9zeDYCx8HuAmhGPz?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        . These figures are presented on a best-effort basis.
      </p>
      <p>For more information and updated details, kindly visit our office .</p>
    </div>
  );
};

export default Disclosure;
